import { createSlice } from "@reduxjs/toolkit";
import {
  addInventory,
  getInventory,
  searchInventory,
} from "./inventory.action";
import { IInventoryState } from "./inventory.interface";

const initialState: IInventoryState = {
  // Add Inventory
  isAddInventoryLoading: false,
  isAddInventorySuccess: false,
  addInventoryError: "",

  // Get Inventory
  isGetInventoryLoading: false,
  isGetInventorySuccess: false,
  getInventoryError: "",
  products: [],
  pagination: {
    length: 0,
    size: 0,
    page: 0,
  },

  // Filters
  filters: {
    search: "",
    sort: "inserted",
    order: "desc",
    page: 0,
    limit: 10,
  },

  // Search Inventory
  isSearchInventoryLoading: false,
  isSearchInventorySuccess: false,
  searchInventoryError: "",
  searchInventoryProducts: [],
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    resetAddInventory: (state) => {
      state.isAddInventoryLoading = false;
      state.isAddInventorySuccess = false;
      state.addInventoryError = "";
    },

    resetGetInventory: (state) => {
      state.isGetInventoryLoading = false;
      state.isGetInventorySuccess = false;
      state.getInventoryError = "";
      state.products = [];
      state.pagination = {
        length: 0,
        size: 0,
        page: 0,
      };
    },

    setFilters: (state, action) => {
      state.filters = action.payload;
    },

    setSearchInventoryProducts: (state, action) => {
      state.searchInventoryProducts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addInventory.pending, (state) => {
      state.isAddInventoryLoading = true;
      state.isAddInventorySuccess = false;
      state.addInventoryError = "";
    });
    builder.addCase(addInventory.fulfilled, (state) => {
      state.isAddInventoryLoading = false;
      state.isAddInventorySuccess = true;
      state.addInventoryError = "";
    });
    builder.addCase(addInventory.rejected, (state, action) => {
      state.isAddInventoryLoading = false;
      state.isAddInventorySuccess = false;
      state.addInventoryError = action.payload;
    });

    builder.addCase(getInventory.pending, (state) => {
      state.isGetInventoryLoading = true;
      state.isGetInventorySuccess = false;
      state.getInventoryError = "";
    });
    builder.addCase(getInventory.fulfilled, (state, action) => {
      state.isGetInventoryLoading = false;
      state.isGetInventorySuccess = true;
      state.getInventoryError = "";
      state.products = action.payload.products;
      state.pagination = action.payload.pagination;
    });
    builder.addCase(getInventory.rejected, (state, action) => {
      state.isGetInventoryLoading = false;
      state.isGetInventorySuccess = false;
      state.getInventoryError = action.payload;
    });

    builder.addCase(searchInventory.pending, (state) => {
      state.isSearchInventoryLoading = true;
      state.isSearchInventorySuccess = false;
      state.searchInventoryError = "";
    });
    builder.addCase(searchInventory.fulfilled, (state, action) => {
      state.isSearchInventoryLoading = false;
      state.isSearchInventorySuccess = true;
      state.searchInventoryError = "";
      state.searchInventoryProducts = action.payload;
    });
    builder.addCase(searchInventory.rejected, (state, action) => {
      state.isSearchInventoryLoading = false;
      state.isSearchInventorySuccess = false;
      state.searchInventoryError = action.payload;
    });
  },
});

export default inventorySlice.reducer;

export const {
  resetAddInventory,
  resetGetInventory,
  setFilters,
  setSearchInventoryProducts,
} = inventorySlice.actions;
